import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const HeroSectionNew = ({ onRegisterClick, settings }) => {
  return (
    <div className="relative min-h-screen text-white pt-24 pb-20 overflow-hidden">
      {/* Background Image with Gradient Overlay - Just like lifedecoder.com */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/mwc6vfaf_Screenshot%202026-03-19%20at%2010.29.33%20AM.png"
          alt="Signature Background"
          className="w-full h-full object-cover"
        />
        {/* Strong gradient overlay from left (dark) to right (semi-transparent) */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0B] via-[#0A0A0B]/90 to-[#0A0A0B]/40"></div>
        {/* Additional vertical gradient for depth */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0B]/60 via-transparent to-[#0A0A0B]/90"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex items-center min-h-[calc(100vh-8rem)]">
          {/* Left Content - Text on gradient side */}
          <div className="max-w-3xl space-y-8">
            <div className="space-y-2">
              <p className="text-[#F5A623] text-sm font-semibold tracking-wider uppercase">
                Transform Your Destiny Through Signature Feng Shui
              </p>
              <h1 className="text-6xl lg:text-7xl font-bold leading-tight">
                Master the <span className="italic text-[#F5A623]">signature.</span>
              </h1>
              <h1 className="text-6xl lg:text-7xl font-bold leading-tight">
                Master the <span className="italic text-[#F5A623]">outcome.</span>
              </h1>
            </div>

            <p className="text-xl text-gray-300 leading-relaxed max-w-2xl">
              Align your personal energy, wealth flow, and opportunities through a proven signature analysis system — practical, precise, and results-driven.
            </p>

            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-1 h-12 bg-[#F5A623]"></div>
                <div>
                  <p className="text-2xl font-bold">{settings?.date || '19th March 2026 (Thursday)'}</p>
                  <p className="text-xl text-gray-400">{settings?.time || '8.00PM (Singapore Time)'}</p>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-4 pt-4">
              <Button 
                onClick={onRegisterClick}
                className="bg-[#F5A623] hover:bg-[#E59400] text-black font-bold px-8 py-6 text-lg rounded-lg group shadow-2xl"
              >
                Join Free Webinar Now
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSectionNew;